const shouldImplement = () => { throw new Error(`Flow::method should be implemented`) };

export default class Flow {

    async view() { shouldImplement() } // which view this flow should render

    async beforeInit() { } // before init, preparing data
    async init() { shouldImplement() } // init shopping cart, etc.
    async afterInit() { } // after init

    async beforeUpdate() { }
    // async update() { } // on shopping cart change
    async afterUpdate() { }

    async beforeContinue() { }
    // async continue() { } // before continue to checkout
    async afterContinue() { }

    async beforeSubmit() { } // before submit, validating & preparing payload
    async submit() { shouldImplement() } // submit payload of this flow to the server
    async afterSubmit() { } // after submit, redirecting to success page etc.

    async preparePaymentData() { } // generate Zuora HPM signature for on session payments

}
